import Script from"next/script";import*as React from"react";import{THIRD_PARTY_SCRIPT_CONFIG}from"@wp/src/appIntegrations/config";const BFCache=()=>{const disableBrowserBackForwardCache=`
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
          location.reload();
        }
      });
      `;return React.createElement(Script,{id:THIRD_PARTY_SCRIPT_CONFIG.bfCache.id,strategy:THIRD_PARTY_SCRIPT_CONFIG.bfCache.strategy,dangerouslySetInnerHTML:{__html:disableBrowserBackForwardCache}})};export default BFCache;